import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }

  debouncedSubmit() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.submit(), 300)
  }
}
